<template>
  <section
    id="career-result"
    class="co-bg-striped"
  >
    <div class="co-container-md px-4 py-12 sm:py-16 md:px-0">
      <div class="mb-12 px-4 text-center md:px-0">
        <h2 class="co-display-7 mb-4 tracking-[.15em]">
          転職実例
        </h2>
        <p class="text-co-gray-600">
          <span class="block">ITスキルを習得し、IT企業へ転職した例をご紹介いたします。</span>
        </p>
      </div>
      <div class="md:flex">
        <div class="relative mb-10 w-full bg-co-gray-200 text-center shadow-[0_0_4px_rgba(51,51,51,0.2)] md:mx-4">
          <div class="p-5">
            <TeCommonRibbon class="te-result-ribbon absolute bg-co-success-500 px-8 py-3">
              事例1
            </TeCommonRibbon>
            <div class="te-result-icon mx-auto mb-5">
              <img
                class="rounded-full"
                src="~/assets/images/Te/TeCareerAbout/Index/Result/ito.jpg"
                alt="伊藤 佑樹さん"
              >
            </div>
            <div class="co-display-10">
              伊藤 佑樹<span class="co-display-13">さん</span>
            </div>
            <span class="block">Webアプリケーションコース受講</span>
            <p class="te-result-detail co-display-10 my-5 font-bold md:text-left">
              受講を決めた時からエンジニアを目指し、製造業から未経験でIT企業へ転職
            </p>
          </div>
        </div>
        <div class="relative mb-10 w-full bg-co-gray-200 text-center shadow-[0_0_4px_rgba(51,51,51,0.2)] md:mx-4">
          <div class="p-5">
            <TeCommonRibbon class="te-result-ribbon absolute bg-co-success-500 px-8 py-3">
              事例2
            </TeCommonRibbon>
            <div class="te-result-icon mx-auto mb-5">
              <img
                class="rounded-full"
                src="~/assets/images/Te/TeCareerAbout/Index/Result/miyata.jpg"
                alt="宮田 佳祐さん"
              >
            </div>
            <div class="co-display-10">
              宮田 佳祐
              <span class="co-display-13">さん</span>
            </div>
            <span class="block">Webアプリケーションコース受講</span>
            <p class="te-result-detail co-display-10 my-5 font-bold md:text-left">
              実務経験ゼロで会計処理からエンジニアへ転身
            </p>
          </div>
        </div>
      </div>
      <div class="md:flex">
        <div class="relative mb-10 w-full bg-co-gray-200 text-center shadow-[0_0_4px_rgba(51,51,51,0.2)] md:mx-4">
          <div class="p-5">
            <TeCommonRibbon class="te-result-ribbon absolute bg-co-success-500 px-8 py-3">
              事例3
            </TeCommonRibbon>
            <div class="te-result-icon mx-auto mb-5">
              <img
                class="rounded-full"
                src="~/assets/images/Te/TeCareerAbout/Index/Result/kishima.jpg"
                alt="木島 恭平さん"
              >
            </div>
            <div class="co-display-10">
              木島 恭平<span class="co-display-13">さん</span>
            </div><span class="block">テックアカデミー Pro受講</span>
            <p class="te-result-detail co-display-10 my-5 font-bold md:text-left">
              スマホゲームのカスタマーサポートからエンジニアに転身
            </p>
          </div>
        </div>
        <div class="relative mb-10 w-full bg-co-gray-200 text-center shadow-[0_0_4px_rgba(51,51,51,0.2)] md:mx-4">
          <div class="p-5">
            <TeCommonRibbon class="te-result-ribbon absolute bg-co-success-500 px-8 py-3">
              事例4
            </TeCommonRibbon>
            <div class="te-result-icon mx-auto mb-5">
              <img
                class="rounded-full"
                src="~/assets/images/Te/TeCareerAbout/Index/Result/yamamoto.jpg"
                alt="山本 泰士さん"
              >
            </div>
            <div class="co-display-10">
              山本 泰士
              <span class="co-display-13">さん</span>
            </div>
            <span class="block">はじめてのプログラミングコース受講</span>
            <p class="te-result-detail co-display-10 my-5 font-bold md:text-left">
              前職からシステムに触れる機会が多く、受講後にシステムエンジニアへ転身
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import TeCommonRibbon from '@/components/Te/TeCommon/Ribbon/TeCommonRibbon/TeCommonRibbon.vue';

const options = {
  components: {
    TeCommonRibbon
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-result-ribbon {
  top: -20px;
  left: -10px;
}

.te-result-icon {
  width: 140px;
}

.te-result-detail {
  line-height: 1.4286;
}

@media (max-width: 767.98px) {
  .te-result-detail {
    font-size: 0.875rem;
  }
}
</style>
